(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('CorporateCurveResultsOpen', CorporateCurveResultsOpen);

    CorporateCurveResultsOpen.$inject = ['$resource', 'DateUtils'];

    function CorporateCurveResultsOpen ($resource, DateUtils) {
        var resourceUrl =  'api/open/corporate-curve-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();
